// apiConfig.js
const API_CONFIG2 = {
      apiUrl: 'https://apirent.azyekoslounges.com/',
  };
  
  export default API_CONFIG2;
 